// Altın Teknik - İşletme Bilgileri
export const BUSINESS_INFO = {
    name: 'Altın Teknik',
    fullName: 'Airfel Klima Antalya - Altın Teknik',
    tagline: 'Airfel Yetkili Bayi & Servis',
    phone1: '0541 539 47 27',
    phone1Clean: '905415394727',
    phone2: '0554 561 65 74',
    phone2Clean: '905545616574',
    whatsapp: '905545616574',
    address: 'Kızılsaray Mah. Şencan Apt. No: 18/A, Muratpaşa/Antalya',
    addressShort: 'Kızılsaray Mah. Şencan Apt. No: 18/A, Muratpaşa/Antalya',
    plusCode: 'VMQQ+VP Muratpaşa, Antalya',
    googleMapsUrl: 'https://maps.google.com/?q=Kızılsaray+Mah+Şencan+Apt+No+18/A+Muratpaşa+Antalya',
    website: 'klimabudur.com',
    workingHours: {
        weekdays: '09:00 - 20:30',
        saturday: '09:00 - 20:30',
        sunday: 'Kapalı',
    },
    workingHoursText: 'Pazartesi - Cumartesi: 09:00 - 20:30 | Pazar: Kapalı',
};

// Hizmetler
export const SERVICES = [
    {
        id: 'montaj',
        title: 'Klima Montajı',
        description: 'Profesyonel ekibimizle güvenli ve hızlı klima montaj hizmeti. Tüm marka ve modellerde uzman kurulum.',
        icon: 'Wrench',
        features: ['Ücretsiz keşif', 'Garanti kapsamında montaj', 'Aynı gün kurulum'],
    },
    {
        id: 'bakim',
        title: 'Klima Bakımı',
        description: 'Klimanızın ömrünü uzatan periyodik bakım hizmeti. Filtre temizliği, gaz kontrolü ve genel sistem kontrolü.',
        icon: 'RefreshCw',
        features: ['Yıllık bakım anlaşması', 'Performans artışı', 'Enerji tasarrufu'],
    },
    {
        id: 'tamir',
        title: 'Klima Tamiri',
        description: 'Tüm klima arızalarında hızlı ve güvenilir tamir hizmeti. Orijinal yedek parça garantisi.',
        icon: 'Settings',
        features: ['Aynı gün servis', 'Orijinal parça', 'İşçilik garantisi'],
    },
    {
        id: 'onarim',
        title: 'Klima Onarımı',
        description: 'Kompresör, kart ve motor onarımları dahil kapsamlı onarım hizmetleri.',
        icon: 'Cog',
        features: ['Detaylı arıza tespiti', 'Uygun fiyat', 'Hızlı çözüm'],
    },
    {
        id: 'gaz',
        title: 'Gaz Dolumu',
        description: 'Klimanızın soğutma performansını artıran profesyonel gaz dolum hizmeti.',
        icon: 'Wind',
        features: ['R410A & R32 gaz', 'Kaçak tespiti', 'Performans garantisi'],
    },
    {
        id: 'demontaj',
        title: 'Klima Demontajı',
        description: 'Taşınma veya değişim için güvenli klima sökme ve taşıma hizmeti.',
        icon: 'ArrowLeftRight',
        features: ['Güvenli söküm', 'Hasarsız taşıma', 'Yeniden kurulum'],
    },
];

// Markalar
export const BRANDS = [
    { name: 'Airfel', featured: true },
    { name: 'Daikin', featured: true },
    { name: 'Mitsubishi', featured: false },
    { name: 'Arçelik', featured: false },
    { name: 'Beko', featured: false },
    { name: 'Vestel', featured: false },
    { name: 'Baymak', featured: false },
    { name: 'Cree', featured: false },
];

// Hizmet Bölgeleri (Antalya)
export const SERVICE_AREAS = [
    'Muratpaşa',
    'Konyaaltı',
    'Kepez',
    'Döşemealtı',
    'Lara',
    'Altınova',
    'Aksu',
    'Kemer',
    'Kundu',
    'Varsak',
    'Hurma',
];

// SSS (Sıkça Sorulan Sorular)
export const FAQ_ITEMS = [
    {
        question: 'Klima bakımı ne sıklıkla yapılmalı?',
        answer: 'Klimanızın verimli çalışması ve uzun ömürlü olması için yılda en az 2 kez (yaz ve kış sezonu öncesi) bakım yaptırmanızı öneriyoruz.',
    },
    {
        question: 'Servis hizmetiniz ücretli mi?',
        answer: 'Keşif ve arıza tespit hizmetimiz ücretsizdir. Yapılacak işlem ve kullanılacak parçalara göre fiyat bilgisi verilir.',
    },
    {
        question: 'Hangi bölgelere hizmet veriyorsunuz?',
        answer: 'Antalya merkez ve çevre ilçeleri dahil Muratpaşa, Konyaaltı, Kepez, Döşemealtı, Lara, Aksu ve Kemer bölgelerine hizmet veriyoruz.',
    },
    {
        question: 'Montaj işlemi ne kadar sürer?',
        answer: 'Standart bir klima montajı yaklaşık 2-3 saat sürmektedir. Özel durumlar için keşif sonrası bilgi verilir.',
    },
    {
        question: 'Garanti kapsamında mısınız?',
        answer: 'Airfel yetkili bayi ve servis olarak tüm işlemlerimiz garanti kapsamındadır. Montaj ve onarım işlemlerinde işçilik garantisi sunuyoruz.',
    },
    {
        question: 'Hafta sonu hizmet veriyor musunuz?',
        answer: 'Cumartesi günleri 09:00-20:30 saatleri arasında hizmet veriyoruz. Pazar günleri kapalıyız ancak acil durumlar için WhatsApp üzerinden ulaşabilirsiniz.',
    },
];

// Resimler - Altın Teknik İşletme Fotoğrafları
export const IMAGES = {
    hero: 'https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/j4bgam82_WhatsApp%20Image%202026-01-08%20at%2016.31.48.jpeg',
    showroom: 'https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/b18yxi5f_WhatsApp%20Image%202026-01-08%20at%2016.31.49.jpeg',
    storefront: 'https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/xdynadg7_WhatsApp%20Image%202026-01-08%20at%2016.31.50%20%281%29.jpeg',
    products: 'https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/fh22p9by_WhatsApp%20Image%202026-01-08%20at%2016.31.50.jpeg',
    acUnit: 'https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/zw98y948_WhatsApp%20Image%202026-01-08%20at%2016.27.24.jpeg',
};
